
import Vue from "vue";
import { NewCompaniesApiFunc, setAccessToken } from "@/api";
import { Company } from "@/models";

import TheTemplate from "../components/TheNoSidebarTemplate.vue";
import BaseCloseButton from "@/components/BaseCloseButton.vue";
import BaseSubmitButton from "@/components/BaseSubmitButton.vue";
import BaseCancelButton from "@/components/BaseCancelButton.vue";
import BaseChuiGaki from "@/components/BaseChuiGaki.vue";

export type DataType = {
  company?: Company;
};

export default Vue.extend({
  name: "CompanyDeleteScreen",

  components: {
    BaseChuiGaki,
    TheTemplate,
    BaseCloseButton,
    BaseSubmitButton,
    BaseCancelButton,
  },

  data(): DataType {
    return {
      company: new Company(),
    };
  },

  computed: {
    companyNameText(): string {
      return this.company?.name || "";
    },
    companyId(): string {
      return this.company?.id || "";
    },
    addressText(): string {
      return this.company?.address || "";
    },
    facilityNameText(): string {
      return this.company?.facilityName || "";
    },
    zipCodeText(): string {
      return this.company?.zipCode || "";
    },
  },

  mounted() {
    this.getCompany();
  },

  methods: {
    async getCompany(): Promise<void> {
      const companyId = this.$router.currentRoute.params.companyId;
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewCompaniesApiFunc().getCompany(companyId);

      if (err != null) {
        this.$handleApiError(err, this.getCompany);
        return;
      }

      this.company = data;
    },

    async archiveCompany(): Promise<void> {
      this.$setLoading(true);

      const companyId = this.$router.currentRoute.params.companyId;
      setAccessToken(this.$auth.accessToken);
      const { err } = await NewCompaniesApiFunc().adminArchiveCompany(companyId);

      if (err != null) {
        this.$handleApiError(err, this.archiveCompany);
        this.$setLoading(false);
        return;
      }
      this.$setLoading(false);
      this.$setChecked(true);
      this.$afterSuccessRequest(() => {
        this.$router.push({
          name: "admin-companies",
          params: {
            updated: "true",
          },
        });
      }, 2);
    },

    afterLeave(): void {
      this.$setChecked(false);
    },
  },
});
